module.exports = __webpack_public_path__ + "static/media/smallmu2.bcb9bcd4.webp";